import { render, staticRenderFns } from "./WidgetSupplierAccountingStats.vue?vue&type=template&id=ff012058&scoped=true"
import script from "./WidgetSupplierAccountingStats.vue?vue&type=script&lang=js"
export * from "./WidgetSupplierAccountingStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff012058",
  null
  
)

export default component.exports